import { render } from "./RowLabelText.vue?vue&type=template&id=2d82f237&scoped=true"
import script from "./RowLabelText.vue?vue&type=script&lang=js"
export * from "./RowLabelText.vue?vue&type=script&lang=js"

import "./RowLabelText.vue?vue&type=style&index=0&id=2d82f237&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d82f237"],['__file',"src/components/RowLabelText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d82f237"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d82f237', __exports__)) {
    console.log('reload')
    api.reload('2d82f237', __exports__)
  }
  
  module.hot.accept("./RowLabelText.vue?vue&type=template&id=2d82f237&scoped=true", () => {
    console.log('re-render')
    api.rerender('2d82f237', render)
  })

}


export default __exports__